export default "__VITE_ASSET__ILSym_Oj__"